<form [formGroup]="universityPersonForm">
    <uiowa-university-person formControlName="universityPerson"
                             [canEdit]="canEdit"
                             [isInvalid]="isInvalid"
                             [personDisplayTemplate]="personDisplay"
                             [personSearchResultsTemplate]="personSearchResults"
                             (onNoPeopleFound)="noPeopleFound()"
                             #universityPerson>
    </uiowa-university-person>
</form>

<ng-template #personDisplay let-person>
    <p class="mb-0">
        <strong>{{person.displayName}}</strong>
        <button type="button" class="btn btn-sm btn-outline-primary align-text-bottom ms-1" (click)="changePerson()" *ngIf="canEdit && !canDelete" title="Edit User">
            <fa-icon [icon]="['fas', 'user-edit']"></fa-icon>
        </button>
        <button type="button" class="btn btn-sm btn-outline-danger align-text-bottom ms-1" (click)="deletePerson()" *ngIf="canDelete" title="Delete User">
            <fa-icon [icon]="['fas', 'user-minus']"></fa-icon>
        </button>
    </p>
    <div *ngIf="person.hawkId">
        <div class="form-text mt-0">{{person.hawkId}} | {{person.univId}} | {{person.emplId}}</div>
        <div class="form-text mt-0">{{person.department}}</div>
        <div class="form-text mt-0">{{person.email}}</div>
        <div class="form-text mt-0">{{person.phone}}</div>
    </div>
    <div *ngIf="!person.hawkId">
        <small class="form-text text-muted mt-0">No person details found</small>
    </div>
</ng-template>

<ng-template #personSearchResults let-people>
    <thead>
        <tr>
            <th></th>
            <th>Name</th>
            <th>HawkID</th>
            <th>Department</th>
        </tr>
    </thead>
    <tbody>
        <tr *ngFor="let person of people">
            <td>
                <button type="button" class="btn btn-primary btn-sm" (click)="universityPerson.onSelectPerson(person)">
                    <fa-icon [icon]="['fas', 'check-square']"></fa-icon> Select
                </button>
            </td>
            <td>{{person.displayName}}</td>
            <td>{{person.hawkId}}</td>
            <td>{{person.department}}</td>
        </tr>
    </tbody>
</ng-template>